import React from 'react';
import {
    Footer,
    Button,
    ArrowItem,
    moment,
    DatePicker,
    PopPicker
} from '@beisen/chaos-ui';
import { covertDateStrForNewDate } from '../../util/helper';
import zhCn from '../../util/zh_CN';
import transLoader from '@beisen/i18n-translation-loader';
require('./DatePicker.scss');

function formatToMode(format) {
    const map = {
        'yyyy/MM/dd HH:mm:ss': 'datetime',
        'yyyy/MM/dd HH:mm': 'datetime',
        'yyyy/MM/dd': 'date',
        'yyyy/MM': 'month',
        'HH:mm': 'time'
    };
    return map[format] || 'date';
}

const defaultTranslation = {
    datePickerTitle: '时间选择',
    clear: '清空',
    confirm: '确定',
    selectHolder: '点击选择',
    required: '必填'
};

/*
注意！！！
1.在使用new Date()时 如需要传入数值  则先要格式化（具体见helper中covertDateStrForNewDate方法）
2.在给DatePicker组件传入数值时  不能传入yyyy/mm 类型的数值  它不识别  请转化为yyyy/mm/dd格式 但在表单展示时 仍应展示为yyyy/mm格式
*/
class DatePick extends React.Component {
    constructor(props) {
        super(props);
        this.handleClearValue = this.handleClearValue.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveDate = this.handleSaveDate.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.state = {
            timeText: props.text
        };
        this.formatType = this.props.cmp_data.data_format;
        this.pickerMode = formatToMode(this.formatType);
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                datePickerTitle: 'date.datePickerTitle',
                clear: 'common.clear',
                confirm: 'common.confirm',
                selectHolder: 'fieldPlaceHolder.selectHolder',
                required: 'common.required'
            }),
            props.translation
        );
    }

    componentWillReceiveProps(nextProps) {
        this.value = moment(
            new Date(
                this.formatTime(this.formatType, nextProps.text) || new Date()
            )
        );
        this.setState({
            timeText: nextProps.text
        });
    }

    // 格式化时间 返回时间字符串
    formatTime(format, time, textOnContent) {
        // 是form外展现的话 没有数据就是没有数据
        let timeText = time;
        if (format == 'HH:mm') {
            if (timeText) {
                timeText = textOnContent
                    ? timeText.match(/\d{2}:\d{2}/g).toString()
                    : moment(new Date()).format('YYYY/MM/DD') + ' ' + timeText;
            } else {
                timeText = textOnContent
                    ? time
                    : moment(new Date()).format('YYYY/MM/DD HH:mm');
            }
        } else if (format == 'yyyy/MM') {
            if (timeText) {
                const realTime = new Date(
                    covertDateStrForNewDate(timeText, 'YYYY/MM')
                );
                timeText = textOnContent
                    ? moment(realTime).format('YYYY/MM')
                    : moment(realTime).format('YYYY/MM/DD');
            } else {
                timeText = textOnContent
                    ? time
                    : moment(new Date()).format('YYYY/MM/DD');
            }
        } else if (format == 'yyyy/MM/dd') {
            if (timeText) {
                timeText = moment(new Date(timeText)).format('YYYY/MM/DD');
            } else {
                timeText = textOnContent
                    ? time
                    : moment(new Date()).format('YYYY/MM/DD');
            }
        }
        return timeText;
    }

    handleChange(date) {
        const format = this.formatType
            .replace('yyyy', 'YYYY')
            .replace('dd', 'DD');
        const timeText = date.format(format);
        this.setState({ timeText }, () => {
            this.props.onBlur &&
                this.props.onBlur({ text: timeText, value: timeText });
        });
    }

    /*-----搜索态方法-----*/

    onDateChange(value) {
        this.value = value;
        this.handleChange(value);
    }

    saveData(date) {
        let format = this.formatType
            .replace('yyyy', 'YYYY')
            .replace('dd', 'DD');
        let timeText = date.format(format);
        this.setState({ timeText }, () => {
            this.props.handleClosePopUp && this.props.handleClosePopUp();
            this.props.onBlur &&
                this.props.onBlur({ text: timeText, value: timeText });
            this.props.synBizData && this.props.synBizData();
        });
    }

    handleSaveDate() {
        let date = this.value;
        if (!this.value) {
            date = moment(
                new Date(
                    this.formatTime(this.formatType, this.state.timeText) ||
                        new Date()
                )
            );
        }
        this.saveData(date);
    }

    handleClearValue(e) {
        e.preventDefault();
        this.props.handleClosePopUp && this.props.handleClosePopUp();
        this.props.onChange && this.props.onChange({ text: '', value: '' });
        this.props.synBizData();
    }

    setdatePreCls() {
        let mode = {
            time: 'pre-picker-time', // 时分
            date: 'pre-picker-date', // 年月日
            month: 'pre-picker-month', // 年月
            datetime: 'pre-picker-datetime'
        };
        return mode[this.pickerMode];
    }

    /*-----编辑态方法-----*/

    handleTouchTap(e) {
        if (!this.props.isReadOnly) {
            this.props.onFocus && this.props.onFocus();
        }
    }

    handleClear() {
        const timeText = '';
        this.setState(
            {
                timeText
            },
            () => {
                this.props.onBlur &&
                    this.props.onBlur({ text: timeText, value: timeText });
            }
        );
    }

    /*-----编辑态展示-----*/

    renderSwipeArrowForm(key) {
        const errMsg =
            this.props.errorMessage && this.props.errorMessage.message;
        const dateTime = this.formatTime(
            this.formatType,
            this.state.timeText,
            'textOnContent'
        );
        return (
            <div>
                <ArrowItem
                    disablePrevent
                    label={this.props.label}
                    onClickForm={this.handleTouchTap}
                    value={dateTime}
                    errorMsg={errMsg}
                    required={this.props.required}
                    cls={this.props.className}
                    isReadOnly={this.props.isReadOnly}
                    desc={this.props.desc}
                    translation={this.translation}
                    styleTitle={this.props.styleTitle}
                />
            </div>
        );
    }

    renderNormalDatePicker() {
        if (this.props.isReadOnly) {
            return this.renderSwipeArrowForm();
        }
        const { translation } = this;
        const timeText = this.formatTime(this.formatType, this.state.timeText);
        const datePicker = (
            <DatePicker
                className={'pre-datePicker ' + this.setdatePreCls()}
                defaultDate={moment(new Date(timeText || new Date()))}
                mode={this.pickerMode}
                locale={zhCn(this.props.locale)}
                minuteStep={1}
                minDate={moment([1900, 0, 1, 0, 0, 0])}
                maxDate={moment([2050, 11, 31, 23, 59, 59])}
            />
        );
        return (
            <PopPicker
                datePicker={datePicker}
                transitionName="rmc-picker-popup-slide-fade"
                maskTransitionName="rmc-picker-popup-fade"
                title={translation.datePickerTitle}
                onDismiss={this.handleClear}
                onChange={this.handleChange}
                okText={translation.confirm}
                dismissText={translation.clear}>
                {this.renderSwipeArrowForm()}
            </PopPicker>
        );
    }

    /*-----搜索态展示-----*/

    renderDatePickerBtn() {
        const { translation } = this;
        return (
            <Footer cls="searchItem-footer-border">
                <Button
                    cls="btn_empty"
                    text={translation.clear}
                    onTouchTap={this.handleClearValue}
                />
                <Button
                    cls="btn_submit"
                    text={translation.confirm}
                    onTouchTap={this.handleSaveDate}
                />
            </Footer>
        );
    }

    renderSearchItemDatePicker() {
        const timeToPicker = this.formatTime(
            this.formatType,
            this.state.timeText
        );
        return (
            <div>
                <DatePicker
                    className={
                        'searchitem_datepicker rmc-date-picker pre-datePicker ' +
                        this.setdatePreCls()
                    }
                    defaultDate={moment(new Date(timeToPicker || new Date()))}
                    date={moment(new Date(timeToPicker || new Date()))}
                    mode={this.pickerMode}
                    locale={zhCn(this.props.locale)}
                    minuteStep={1}
                    minDate={moment([1900, 0, 1, 0, 0, 0])}
                    maxDate={moment([2050, 11, 31, 23, 59, 59])}
                    onDateChange={this.onDateChange}
                />
                {this.renderDatePickerBtn()}
            </div>
        );
    }

    render() {
        return this.props.pop_type == 'searchItem'
            ? this.renderSearchItemDatePicker()
            : this.renderNormalDatePicker();
    }
}
export default DatePick;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DatePicker/DatePicker.js